import { FC, HTMLAttributes } from 'react';

type CosmostationWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const CosmostationWallet: FC<CosmostationWalletProps> = ({
  size = 16,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="400" height="400" fill="url(#cosmostation-a)" />
      <path
        d="M152.548 281.071L97.4207 185.587C96.0464 183.207 95.3228 180.507 95.3228 177.758C95.3228 175.01 96.0464 172.31 97.4207 169.929L152.548 74.4919C153.923 72.1115 155.9 70.135 158.28 68.7607C160.66 67.3865 163.361 66.663 166.109 66.6631H276.319C279.067 66.663 281.768 67.3865 284.148 68.7607C286.528 70.135 288.505 72.1115 289.879 74.4919L345.194 170.022L318.072 185.68L267.465 98.0716H175.15L129.062 177.851L179.67 265.506L152.548 281.071Z"
        fill="#9866FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.116 68.3333C163.66 68.3332 161.247 68.9797 159.12 70.2077C156.993 71.4357 155.226 73.2018 153.998 75.3288L98.8706 170.766C98.8705 170.766 98.8706 170.766 98.8706 170.766C97.6427 172.893 96.9959 175.306 96.9959 177.762C96.9959 180.217 97.6426 182.63 98.8706 184.757L153.167 278.801L177.397 264.896L127.144 177.854L174.194 96.4085H268.433L318.689 183.407L342.922 169.417L288.444 75.3306C287.216 73.2037 285.448 71.4357 283.321 70.2077C281.194 68.9797 278.781 68.3332 276.325 68.3333H166.116ZM157.453 67.3209C160.087 65.8004 163.075 64.9999 166.116 65H276.325C279.366 64.9999 282.354 65.8004 284.988 67.3209C287.622 68.8414 289.809 71.0283 291.329 73.6621L347.479 170.635L317.469 187.96L266.509 99.7418H176.118L130.993 177.855L181.955 266.123L151.943 283.347L95.9838 186.424C94.4633 183.79 93.6626 180.803 93.6626 177.762C93.6626 174.72 94.4633 171.733 95.9838 169.099L151.112 73.6621C151.112 73.662 151.112 73.6622 151.112 73.6621C152.632 71.0285 154.82 68.8414 157.453 67.3209Z"
        fill="#9866FF"
      />
      <path
        d="M233.367 333.038H122.925C120.176 333.038 117.476 332.314 115.096 330.94C112.715 329.566 110.738 327.589 109.364 325.209L54.2827 229.818L81.3574 214.161L131.965 301.815H224.047L270.088 221.989L219.527 134.381L246.602 118.723L301.73 214.161C303.104 216.541 303.828 219.241 303.828 221.989C303.828 224.738 303.104 227.438 301.73 229.818L246.602 325.302C245.251 327.624 243.322 329.556 241.003 330.912C238.684 332.267 236.053 333 233.367 333.038V333.038Z"
        fill="#00E0EC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M247.204 116.443L303.166 213.325C304.687 215.958 305.488 218.946 305.488 221.987C305.488 225.028 304.687 228.016 303.166 230.649L248.039 326.133C246.543 328.703 244.405 330.848 241.837 332.349C239.27 333.849 236.358 334.66 233.384 334.702L233.361 333.035V334.702H122.918C119.877 334.702 116.89 333.902 114.256 332.381C111.622 330.861 109.435 328.673 107.914 326.04L52 229.207L81.9603 211.881L132.921 300.147H223.078L268.158 221.987L217.245 133.77L247.204 116.443ZM233.348 331.369C235.743 331.333 238.088 330.679 240.155 329.471C242.225 328.261 243.946 326.537 245.153 324.465C245.153 324.464 245.152 324.466 245.153 324.465L300.28 228.983C301.508 226.856 302.154 224.443 302.154 221.987C302.154 219.531 301.508 217.119 300.28 214.992L245.986 120.999L221.796 134.988L272.006 221.987L225.003 303.48H130.996L80.7415 216.436L56.5524 230.425L110.801 324.373C112.029 326.5 113.795 328.266 115.922 329.494C118.049 330.722 120.462 331.369 122.918 331.369H233.348Z"
        fill="#00E0EC"
      />
      <defs>
        <linearGradient
          id="cosmostation-a"
          x1="200"
          y1="0"
          x2="200"
          y2="400"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F3F3F3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CosmostationWallet;
